var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.style.wrapper},[_c('h3',{class:_vm.style.basicTitle},[_vm._v("残日数")]),_c('div',{class:_vm.variableClass},[_c('span',{class:_vm.style.bigNumber},[_vm._v(_vm._s(_vm.remainingDays))]),_c('span',{class:_vm.style.unit},[_vm._v("日")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }